module.exports = __webpack_public_path__ + "10325ae61fd61481aa1680caa83bbdee.pdf";